module.exports = __webpack_public_path__ + "img/bell.998e8abf.svg";